import { downgold, usergolddefualt, logout } from "assets/icons/index";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { DASHBOARD_PATH, DONATIONS_PATH } from "Routes/paths";

interface UserInfoProps {
  data: any;
}

const UserInfo = ({ data }: UserInfoProps) => {
  const { t, i18n } = useTranslation();
  const [showDropDown, setShowDropDown] = useState(false);

  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="relative">
      {/* user info  */}
      <div
        onClick={() => setShowDropDown(!showDropDown)}
        className="flex items-center gap-[10px] cursor-pointer"
      >
        <img src={usergolddefualt} alt="" />
        <img src={downgold} alt="" />
      </div>

      {/* dropdown */}
      {showDropDown && (
        <div
          className={`w-[260px] p-[18px] absolute top-[190%]  bg-white rounded-[20px] border shadow-shadow_main ${
            i18n.language === "en"
              ? "right-[-9%] lg:right-[-40%] 2xl:right-[-114%]"
              : "left-[-9%] lg:left-[-40%] 2xl:left-[-114%]"
          }`}
        >
          {/* upper section  ******************************/}
          <div
            // to={DASHBOARD_PATH}
            className="flex items-center gap-[10px] pb-[15px] border-b-[1px] cursor-pointer"
          >
            <img
              className="w-[48px] min-w-[48px]"
              src={usergolddefualt}
              alt=""
            />

            <div className="flex flex-col gap-[3px] max-w-[140px]">
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[16px] text-[#444444] text-ellipsis line-clamp-1 `}
              >
                {data?.user?.full_name}
              </p>
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[400] text-[12px] text-[#808184] text-ellipsis line-clamp-1 `}
              >
                {data?.user?.email_id}
              </p>
            </div>
          </div>

          {/* lower section  ******************************/}
          <div className="flex flex-col gap-[8px] pt-[15px]">
            <p
              onClick={() => navigate(`${DONATIONS_PATH}`)}
              className={` font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] text-[14px] text-[#444444] cursor-pointer hover:text-first_color duration-300`}
            >
              {t("Donations")}
            </p>

            <div
              onClick={() => {
                dispatch({ type: "LOG_OUT" });
              }}
              className="flex items-center gap-[5px] cursor-pointer"
            >
              <img className="w-[15px] min-w-[15px]" src={logout} alt="" />
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[14px] text-first_color hover:text-first_color/75 duration-300`}
              >
                {t("Logout")}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
